// The location Users table's initials avatar (B1370). Legacy LocationUsersIndex.vue colours each one by a hash of the
// user's name over eleven Quasar colours (`getAvatarColor`), so the same person always gets the same circle. The fills
// are legacy's computed ones in each theme: the six theme colours follow the tokens (info and warning are translucent
// in dark, as legacy's are), and the five Quasar palette colours are the same in both themes (measured on GG LA at
// 1600, session 63b3724f).
//
// Legacy draws white initials on every fill, which is unreadable on several (light warning 1.8:1, cyan 2.2:1, teal
// 3.0:1, info 3.4:1; dark primary, positive and secondary about 1.6:1): legacy bug B1370, fixed (ledger L997). Each
// fill takes whichever ink reads better on it in that theme, white or the dark body ink, so every pair reaches 4.5:1
// but blue-grey and dark's translucent warning, where white is the better ink at 4.4:1.

interface AvatarFill {
  /** Legacy's Quasar colour name, as `getAvatarColor` returns it. */
  readonly legacyColor: string;
  readonly className: string;
}

const WHITE = 'text-white';
const DARK_IN_DARK = 'text-white dark:text-text-inverted';
const DARK_IN_LIGHT = 'text-text-1 dark:text-white';
const DARK = 'text-text-1 dark:text-text-inverted';

const PRIMARY: AvatarFill = { legacyColor: 'primary', className: `bg-primary ${DARK_IN_DARK}` };

/** Legacy's order: the hash indexes this list. */
export const AVATAR_FILLS: readonly AvatarFill[] = [
  PRIMARY,
  { legacyColor: 'secondary', className: `bg-secondary ${DARK_IN_DARK}` },
  { legacyColor: 'accent', className: `bg-accent ${WHITE}` },
  { legacyColor: 'positive', className: `bg-positive ${DARK_IN_DARK}` },
  { legacyColor: 'info', className: `bg-info ${DARK_IN_LIGHT}` },
  { legacyColor: 'warning', className: `bg-warning ${DARK_IN_LIGHT}` },
  { legacyColor: 'deep-purple', className: `bg-[#673ab7] ${WHITE}` },
  { legacyColor: 'cyan', className: `bg-[#58bae8] ${DARK}` },
  { legacyColor: 'teal', className: `bg-[#26a69a] ${DARK}` },
  { legacyColor: 'indigo', className: `bg-[#4f62cc] ${WHITE}` },
  { legacyColor: 'blue-grey', className: `bg-[#607d8b] ${WHITE}` },
];

/** Legacy's `getAvatarColor` hash, kept bit for bit (the shift truncates to 32 bits, the sum does not). */
export function avatarFillOf(name: string): AvatarFill {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_FILLS[Math.abs(hash) % AVATAR_FILLS.length] ?? PRIMARY;
}
